<template>
  <div class="login-view">
    <div class="form-side">
      <div class="login-pane">
        <div
          class="logo"
          @click="pushHome"
        >
          <img
            alt="Fuell logo"
            :src="require('@/assets/img/logo.svg')"
          >
        </div>
        <login-sign-in-form
          @login="handleLogin"
          @showForgetPasswordForm="showForgetPasswordForm"
        ></login-sign-in-form>
        <!-- <i18n
          tag="small"
          class="Fuell-Text mt-2"
          path="user_self_onboarding_create_account"
        >
          <template v-slot:signup>
            <span class="text-primary clickable" @click="navigateToSignup">{{$t('user_self_onboarding_create_account_signup_here')}}</span>
          </template>
        </i18n> -->

        <div class="d-flex flex-column app-download">
          <span
            class="text-center"
            v-t="{path:'ACTION_DOWNLOAD_APP'}"
          ></span>

          <div class="d-flex justify-content-center column">
            <a
              class="d-flex h-100"
              rel="noopener noreferrer"
              target="_blank"
              style="margin-top:10px"
              href="https://apps.apple.com/us/app/fuell/id1502092784?itsct=apps_box&itscg=30200"
            >
              <img
                :src="require('@/assets/img/apple-store-badge.svg')"
                alt="Download on the App Store"
                class="align-self-center"
              ></a>
            <a
              rel="noopener noreferrer"
              class="d-flex  h-100 google-badge-column"
              target="_blank"
              href='https://play.google.com/store/apps/details?id=com.fuell&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
            >
              <img
                alt='Get it on Google Play'
                :src="require('@/assets/img/google-play-badge.svg')"
              /></a>
          </div>
        </div>
      </div>

    </div>
    <div class="image-side"></div>

    <!-- modals -->
    <login-forgot-password-form
      @close="handleCloseForgotPassword"
      v-if="showForgotPasswordFormFlag"
    ></login-forgot-password-form>
  </div>
</template>

<script>
import LoginSignInForm from '../_components/LoginSignInForm'
import LoginForgotPasswordForm from '../_components/LoginForgotPasswordForm'

export default {
  name: 'Login',
  components: {
    LoginSignInForm, LoginForgotPasswordForm
  },
  data () {
    return {
      showForgotPasswordFormFlag: false
    }
  },
  methods: {
    showForgetPasswordForm () {
      this.showForgotPasswordFormFlag = true
    },
    handleCloseForgotPassword () {
      this.showForgotPasswordFormFlag = false
    },
    handleLogin (event) {
      this.$store.dispatch('LoginStore/login', event)
    },
    pushHome () {
      this.$router.push({ name: 'login' })
    },
    navigateToSignup () {
      this.$router.push({ name: 'customer-signup' })
    }

  }
}
</script>

<style lang="scss" scoped>
.login-pane {
  .app-download {
    max-width: 325px;
    width: 100%;
    margin-top: 63px;
  }
  .text-center {
    color: var(--gray);
    font-size: 15px;
  }
}
</style>
